import axios from "axios";
import { tokenManager } from "../utils/tokenManager";

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) return envUrl.replace(/\/$/, "");
  return "http://localhost:8000";
};

// Separate axios instance for authentication backend
const authApi = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  withCredentials: false
});

// Add request logging
authApi.interceptors.request.use(
  (config) => {

    const token = tokenManager.getToken();
    const isLoginEndpoint = ["/auth/login/", "/auth/lookup/", "/auth/demo-login/", "/auth/send-otp/", "/auth/refresh/"].some(ep => config.url?.includes(ep));

    if (token && !isLoginEndpoint) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error(`🔴 Auth Request Error [${error.config?.method?.toUpperCase()} ${error.config?.url}]:`, error);
    if (error.response?.status === 403) {
      console.error("403 Forbidden Details:", error.response.data);
    }
    return Promise.reject(error);
  }
);

// Response interceptor
authApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const url = error.config?.url;
    const isLoginEndpoint = ["/auth/login/", "/auth/lookup/"].some(ep => url?.includes(ep));

    const isNetworkSuspended =
      error.code === 'ERR_NETWORK_IO_SUSPENDED' ||
      error.code === 'ERR_CANCELED' ||
      error.code === 'ECONNABORTED' ||
      axios.isCancel?.(error);

    if (!isLoginEndpoint && !isNetworkSuspended) {
      console.error(`🔴 API Error ${error.response?.status || 'Network'} on ${url}:`, error.response?.data || error.message);
    }

    if (error.response?.status === 401) {
      console.error(`⚠️ [authAxios] 401 detected on ${url}. Wiping tokens!`);
      tokenManager.removeToken();
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default authApi;
